import React from "react";
import { Link } from "@remix-run/react";
import { useSiteNav } from "@/overrides/site/SiteNavContext";

/**
 * Kept so the HomepageTabs.before extension still replaces the plugin mega-menu.
 * The header itself renders the product menu from the saved site nav.
 */
export const CategoryMenu: React.FC = () => {
  const menu = useSiteNav().find((item) => item.id === "product-menu");
  if (!menu) return null;
  return (
    <div className="nav-dropdown">
      <Link to={menu.href} className="nav-dropdown-trigger">
        {menu.label}
      </Link>
      {menu.children.length > 0 && (
        <div className="nav-dropdown-menu">
          {menu.children.map((child) => (
            <Link key={child.id} to={child.href}>{child.label}</Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryMenu;
